module.exports = __webpack_public_path__ + "static/media/hamburger.b705feed.svg";